// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1rL8Q","savePackageButton":"ClientWallet_savePackageButton__iePAO"};